import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import OpportunityService from '../services/opportunityService';

export const useListOpportunities = ({ recordTypeId, sortConfig }) => {
  const [opportunities, setOpportunities] = useState(null);
  const [totalOpportunities, setTotalOpportunities] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isLoadingOpportunities, setIsLoadingOpportunities] = useState(false);

  const getOpportunities = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingOpportunities(true);

      const orderType =
        sortConfig?.direction === null ||
          sortConfig?.direction === undefined ||
          // Algumas páginas estão passando `ascending` enquanto outras passam `ascendant`. Para evitar modificar muitos arquivos, aceita-se ambos os modos.
          (sortConfig?.direction === 'ascending' || sortConfig?.direction === 'ascendant')
          ? 'ASC'
          : 'DESC';

      const orderBy = sortConfig?.key;

      OpportunityService.getOpportunities(recordTypeId, { ...params, orderType, orderBy }, {
        page,
        limit: defaultLimit
      })
        .then((response) => {
          setOpportunities(response.data.data);
          setTotalOpportunities(response.data.totalRegisters);
          setTotalAmount(response.data.totalAmount);
        })
        .finally(() => setIsLoadingOpportunities(false));
    },
    [recordTypeId, sortConfig]
  );

  const getAndReturnOpportunities = useCallback(
    (page = 1, params = {}, limit = 20) => {
      return OpportunityService.getOpportunities(recordTypeId, params, {
        page,
        limit
      });
    },
    [recordTypeId]
  );

  const getAllOpportunities = useCallback(
    (params = {}) => {
      setIsLoadingOpportunities(true);

      OpportunityService.getAllOpportunities(recordTypeId, params)
        .then((response) => {
          setOpportunities(response.data.data);
          setTotalOpportunities(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingOpportunities(false));
    },
    [recordTypeId]
  );

  const clearOpportunities = useCallback(() => {
    setOpportunities(null);
    setTotalOpportunities(0);
    setIsLoadingOpportunities(false);
  }, []);

  return {
    opportunities,
    totalOpportunities,
    totalAmount,
    isLoadingOpportunities,
    getOpportunities,
    clearOpportunities,
    getAllOpportunities,
    getAndReturnOpportunities
  };
};
